const footerBenefitsSlider = {
    selector: '.js-footer-benefits-slider',
    active: false,
    settings: {
        infinite: false,
        autoplay: true,
        speed: 400,
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 599,
                settings: 'unslick',
            },
            {
                breakpoint: 479,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            }
        ]
    },
    callbacks: {
        destroy: function() {
            footerBenefitsSlider.active = false;
        }
    }
}

function initBenefitsSlider() {
    $benefitsSlider = $(footerBenefitsSlider.selector);

    if (checkMedia('cxs')) {
        initSlickSlider(footerBenefitsSlider);
    }
}

$(function() {
    initBenefitsSlider();

    $(window).on('resize', function() {
        initBenefitsSlider();
    })
});